import { render, staticRenderFns } from "./over-drop-ui.vue?vue&type=template&id=0989c70e&"
import script from "./over-drop-ui.vue?vue&type=script&lang=js&"
export * from "./over-drop-ui.vue?vue&type=script&lang=js&"
import style0 from "./over-drop-ui.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports